import { Data } from './data';

export class Taxe extends Data {

    designation: string;
    valeur: number;
    is_about_h_t: boolean;
    type_calcul: string;

    // parent: CatProduit;

    constructor() {

        super();
        this.is_about_h_t = true;
    }

    get renderAboutHT(): string{

        if(this.is_about_h_t)
        return 'oui';
        else
        return 'non';
    }

    /* get value(): number{

        return this.id;
    } */



}
